import React from 'react';

const PrimaryButton = ({ title, onClick, disabled, spinner = true, disabledTitle, style, disabledColor = '#a0d8f1' }) => {
    return (
        <div style={{ width: style?.width || '100%', display: 'flex', justifyContent: 'center' }}>
            <button
                type="button"
                onClick={disabled ? undefined : onClick}
                disabled={disabled}
                className={`primary-button-container ${disabled ? 'disabled' : ''}`}
                style={{
                    ...style,
                    backgroundColor: disabled ? disabledColor : "#00b0ff",
                    padding: '15px 0',
                    width: style?.width || '100%',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                }}
            >
                {disabled && spinner && (
                    <div className="spinner">
                        <div className="circle"></div>
                    </div>
                )}

                <span className='title'>{disabled && disabledTitle ? disabledTitle : title}</span>
            </button>
        </div>
    );
};

export default PrimaryButton;
